/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum TextDividerPatterns {
    RN = '\r\n',
    DoubleN = '\n\n',
    SingleN = '\n',
    Br = '<br />',
}
